export default {
  st_config: {
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL
  },
  editor_url: process.env.VUE_APP_STC_BASE_URL,
  amplitude_key: process.env.VUE_APP_AMPLITUDE_KEY
}
